import { Badge } from '@eluve/components';

export type ScopeType = 'global' | 'tenant' | 'user';

interface ScopeBadgeProps {
  scope: ScopeType;
}

export const ScopeBadge: React.FC<ScopeBadgeProps> = ({ scope }) => {
  switch (scope) {
    case 'user':
      return <Badge variant="info">User</Badge>;
    case 'tenant':
      return <Badge variant="success">Organization</Badge>;
    case 'global':
    default:
      return <Badge variant="default">Global</Badge>;
  }
};

export const getScopeFromDefault = (ptDefault: {
  userId?: string | null;
  tenantId?: string | null;
}): ScopeType => {
  if (ptDefault.userId) {
    return 'user';
  }
  if (ptDefault.tenantId) {
    return 'tenant';
  }
  return 'global';
};
